import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {assignmentRoutes} from '../assignment-routes';

export function useOpenAddAssignment() {
	const navigate = useNavigate();

	return useCallback(() => {
		navigate(assignmentRoutes.assignmentAdd);
	}, [navigate]);
}